// Centralised runtime config for frontend (Create React App)

// Dynamic API base URL that uses the current hostname
const getApiUrl = () => {
  // If REACT_APP_API_URL is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Otherwise, use the current hostname for API calls
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${protocol}//${hostname}${port}/api`;
};

export const API_BASE: string = getApiUrl();
export const STRIPE_PK: string = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? ''; 